import type { EditorCanvas } from "replo-utils/lib/misc/canvas";

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ViewportStore {
  currentViewport: EditorCanvas;
  setCurrentViewport: (viewport: EditorCanvas) => void;
}

export const useViewportStore = create<ViewportStore>()(
  persist(
    (set) => ({
      currentViewport: "mobile",
      setCurrentViewport: (viewport) => set({ currentViewport: viewport }),
    }),
    {
      name: "replo-editor-viewport",
    },
  ),
);
